import CabeceraTorneosPais from '../torneos/pais/CabeceraTorneosPais.js';
import CabeceraTorneosInt from '../torneos/internacionales/CabeceraTorneosInt.js';
import { Torneo as Filtros } from '../constantes/Filtros.js';
import { Partidos as TipoLista } from '../constantes/Filtros.js';
import { TituloPagina, TituloTexto } from './Funciones.js';
import { DecadaAnio } from './FuncionesFecha';

export const DecadasTorneos = (torneos) => {
  let salida = [];
  let decadaActual = DecadaAnio(torneos[0].anioInicio);
  for (const torneo of torneos) {
    if (decadaActual !== DecadaAnio(torneo.anioInicio)) {
      salida.push(decadaActual);
      decadaActual = DecadaAnio(torneo.anioInicio);
    }
  }
  salida.push(decadaActual);
  return salida;
};

export const ArmarListaTorneosAgrupacion = (lista) => {
  let resultMap = new Map();

  // mapeo de relaciones padres/hijos
  const mapPadreHijo = new Map();
  for (const item of lista) {
    if (item.torneoPadre) {
      mapPadreHijo.set(item.torneoPadre.id, item);
    }
  }

  for (const item of lista) {
    const itemBase = item.torneoPadre ?? item;
    const itemCopia = { ...itemBase }; // para no modificar el objeto original

    const hijo = mapPadreHijo.get(itemCopia.id);
    itemCopia.hijo = hijo;

    resultMap.set(itemCopia.id, itemCopia);
  }

  return [...resultMap.values()];
};

export const CabeceraTorneo = (datosElegidos, onDatoElegido) => {
  if (datosElegidos) {
    if (datosElegidos.pais) {
      return <CabeceraTorneosPais datosElegidos={datosElegidos} onDatoElegido={onDatoElegido} />;
    } else if (datosElegidos.torneo) {
      return <CabeceraTorneosInt datosElegidos={datosElegidos} onDatoElegido={onDatoElegido} />;
    }
  } else {
    return null;
  }
};

export const IdParamsDatos = (filtro, parameters, datosElegidos) => {
  if (parameters) {
    switch (filtro) {
      case Filtros.PAIS: {
        return parameters.idPais;
      }
      case Filtros.DIVISION: {
        return parameters.idDivision;
      }
      case Filtros.TIPO_TORNEO: {
        return parameters.codTipoTorneo;
      }
      case Filtros.TORNEO: {
        return parameters.idTorneo;
      }
      case Filtros.EQUIPO: {
        return parameters.idEquipo;
      }
      case Filtros.ETAPA: {
        return parameters.codEtapa;
      }
      default: {
        return null;
      }
    }
  } else if (datosElegidos) {
    switch (filtro) {
      case Filtros.PAIS: {
        return datosElegidos.pais.id;
      }
      case Filtros.DIVISION: {
        return datosElegidos.division.id;
      }
      case Filtros.TIPO_TORNEO: {
        return datosElegidos.tipoTorneo.codigo;
      }
      case Filtros.TORNEO: {
        return datosElegidos.torneo.id;
      }
      case Filtros.EQUIPO: {
        return datosElegidos.equipo.id;
      }
      case Filtros.ETAPA: {
        return datosElegidos.etapa.codigo;
      }
      default: {
        return null;
      }
    }
  } else {
    return null;
  }
};

export const NavigatePath = (filtro, valor, datosElegidos) => {
  switch (filtro) {
    case Filtros.PAIS: {
      return '/torneosPais/' + valor.id;
    }
    case Filtros.DIVISION: {
      return '/torneosPais/' + datosElegidos.pais.id + '/division/' + valor.id;
    }
    case Filtros.TIPO_TORNEO: {
      return '/torneosInt/' + valor.codigo;
    }
    case Filtros.TORNEO: {
      return '/torneos/' + valor.id;
    }
    case Filtros.ETAPA: {
      return '/torneos/' + datosElegidos.torneo.id + '/etapa/' + valor.codigo;
    }
    case Filtros.EQUIPO: {
      return '/torneos/' + datosElegidos.torneo.id + '/equipo/' + valor.id;
    }
    default: {
      return '';
    }
  }
};

export const OrdenarListaFechaDesc = (lista) => {
  return lista.sort((a, b) => {
    const torneoA = new Date(a.anioInicio, a.mesInicio - 1, a.diaInicio);
    const torneoB = new Date(b.anioInicio, b.mesInicio - 1, b.diaInicio);
    return torneoB - torneoA;
  });
};

export const TituloPaginaTorneo = (filtro, datosElegidos, pagina) => {
  let titulo = '';
  switch (filtro) {
    case Filtros.PAIS: {
      return TituloTexto(datosElegidos.pais && datosElegidos.pais.nombre);
    }
    case Filtros.DIVISION: {
      return TituloTexto(datosElegidos.division && datosElegidos.division.descripcion);
    }
    case Filtros.TIPO_TORNEO: {
      return TituloTexto(datosElegidos.tipoTorneo && datosElegidos.tipoTorneo.nombre);
    }
    case Filtros.TORNEO: {
      return TituloTexto(datosElegidos.torneo && datosElegidos.torneo.descripcion);
    }
    case Filtros.ETAPA: {
      titulo = '';
      if (datosElegidos.torneo) {
        titulo += datosElegidos.torneo.descripcion;
        if (datosElegidos.etapa) {
          titulo += ' - ' + datosElegidos.etapa.descripcion;
        }
      }
      return TituloTexto(titulo);
    }
    case Filtros.EQUIPO: {
      titulo = '';
      if (datosElegidos.equipo) {
        titulo += datosElegidos.equipo.nombre;
        if (datosElegidos.torneo) {
          titulo += ' - ' + datosElegidos.torneo.descripcion;
        }
      }
      return TituloTexto(titulo);
    }
    default: {
      return TituloPagina(pagina);
    }
  }
};

export const TorneoEnDecada = (torneo, decada) => {
  return (
    torneo &&
    Number(torneo.anioInicio) >= Number(decada) + 1 &&
    Number(torneo.anioInicio) <= Number(decada) + 10
  );
};

export const URLFiltro = (filtro, parameters, datosElegidos) => {
  switch (filtro) {
    case Filtros.PAIS: {
      return 'paises/' + IdParamsDatos(filtro, parameters, datosElegidos);
    }
    case Filtros.DIVISION: {
      return (
        'paises/' +
        datosElegidos.pais.id +
        '/divisiones/' +
        IdParamsDatos(filtro, parameters, datosElegidos)
      );
    }
    case Filtros.TIPO_TORNEO: {
      return 'tipos_torneo/' + IdParamsDatos(filtro, parameters, datosElegidos);
    }
    case Filtros.TORNEO: {
      return 'torneos/' + IdParamsDatos(filtro, parameters, datosElegidos);
    }
    case Filtros.EQUIPO: {
      return 'equipos/' + IdParamsDatos(filtro, parameters, datosElegidos);
    }
    case Filtros.ETAPA: {
      return 'torneos/parametros/etapas/' + IdParamsDatos(filtro, parameters, datosElegidos);
    }
    default: {
      return null;
    }
  }
};

export const URLListaPartidos = (filtro, datosElegidos) => {
  let url = '';
  if (datosElegidos.torneo) {
    url = 'torneos/' + datosElegidos.torneo.id;
    switch (filtro) {
      case TipoLista.EQUIPO: {
        if (datosElegidos.equipo) {
          url += '/participantes/' + datosElegidos.equipo.id;
        } else {
          url = '';
        }
        break;
      }
      case TipoLista.ETAPA:
      case TipoLista.FECHAS_ETAPA: {
        if (datosElegidos.etapa && datosElegidos.etapa.etapa) {
          // Usar el codigo de la etapa (no el id de torneo_etapa)
          url += '/etapas/' + datosElegidos.etapa.etapa.codigo;
        } else {
          url = '';
        }
        break;
      }
      default: {
        url = '';
      }
    }
  }
  if (url !== '') {
    url += '/partidos';
  }
  return url;
};

export const URLPosicionesTorneo = (datosElegidos) => {
  let url = '';
  if (datosElegidos.torneo) {
    url = 'torneos/' + datosElegidos.torneo.id;
    // Si hay etapa seleccionada, usar el código de etapa en la ruta
    if (datosElegidos.etapa && datosElegidos.etapa.etapa) {
      url += '/etapas/' + datosElegidos.etapa.etapa.codigo + '/posiciones';
    } else {
      // Si no hay etapa, no se puede obtener posiciones
      url = '';
    }
  }
  return url;
};

export const ValorVolver = (filtro, datosElegidos) => {
  switch (filtro) {
    case Filtros.PAIS: {
      return datosElegidos.pais;
    }
    case Filtros.DIVISION: {
      return datosElegidos.division;
    }
    case Filtros.TIPO_TORNEO: {
      return datosElegidos.tipoTorneo;
    }
    case Filtros.TORNEO: {
      return datosElegidos.torneo;
    }
    case Filtros.EQUIPO: {
      return datosElegidos.equipo;
    }
    case Filtros.ETAPA: {
      return datosElegidos.etapa;
    }
    default: {
      return null;
    }
  }
};
